'use client';

import { proseClassName } from './proseClassName';

interface HtmlContentProps {
  /** Admin-authored HTML — only use with trusted content from the blog editor */
  content: string;
}

// eslint-disable-next-line react/no-danger
export function HtmlContent({ content }: HtmlContentProps) {
  return (
    <article
      className={proseClassName}
      // Admin-authored content only — not from end users
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
